import React, { FC } from 'react';
// import { Typography } from '@mui/material';
import Typography from '@/components/shared/typography/typography.component';
import classes from './style.module.scss';
import Image from 'next/image';

const FieldValue: FC<{ logo: any; label: string; value: string }> = ({ logo, label, value }) => {
  return (
    <div className={classes.container}>
      <div className={classes.label}>
        <Image src={logo} alt={label} width={12} />
        <Typography variant="body2Medium" color="#344054">
          {label}
        </Typography>
      </div>
      <Typography variant="body2" color="#344054" style={{ textAlign: 'end' }}>
        {value}
      </Typography>
    </div>
  );
};

export default FieldValue;
